// useAlarmSound.jsx
import { useState, useRef, useEffect, useCallback } from 'react';

export default function useAlarmSound({ mutedByDefault = true } = {}) {
  const [enabled, setEnabled] = useState(!mutedByDefault);
  const refs = useRef({});

  useEffect(() => {
    if (typeof window === 'undefined' || typeof Audio === 'undefined') return;

    // 필요한 사운드들을 여기에 등록
    refs.current = {
      alarm: new Audio('/sounds/WEB_Alarm.mp3'),
    };

    Object.values(refs.current).forEach((a) => {
      a.preload = 'auto';
      a.volume = 0.7;
    });

    // 사용자 제스처로 오디오 언락
    const unlock = () => {
      const list = Object.values(refs.current);
      Promise.allSettled(
        list.map((a) =>
          a.play().then(() => {
            a.pause();
            a.currentTime = 0;
          })
        )
      ).finally(() => {
        window.removeEventListener('click', unlock);
        window.removeEventListener('touchstart', unlock);
      });
    };
    window.addEventListener('click', unlock, { once: true });
    window.addEventListener('touchstart', unlock, { once: true });

    return () => {
      window.removeEventListener('click', unlock);
      window.removeEventListener('touchstart', unlock);
      Object.values(refs.current).forEach((a) => {
        try { a.pause(); } catch {}
      });
      refs.current = {};
    };
  }, []);

  // 단발 재생
  const play = useCallback((name) => {
    if (!enabled) return;
    const a = refs.current[name];
    if (!a) return;
    try { a.loop = false; a.currentTime = 0; a.play(); } catch {}
  }, [enabled]);

  // 반복 재생 시작
  const startLoop = useCallback((name) => {
    if (!enabled) return;
    const a = refs.current[name];
    if (!a) return;
    try {
      a.loop = true;
      if (a.paused || a.ended) {
        a.currentTime = 0;
        a.play();
      }
    } catch {}
  }, [enabled]);

  // 정지
  const stop = useCallback((name) => {
    const a = refs.current[name];
    if (!a) return;
    try { a.loop = false; a.pause(); a.currentTime = 0; } catch {}
  }, []);

  return { play, startLoop, stop, enabled, setEnabled };
}
